import { heroData } from '@/mocks/home';

export default function Hero() {
  return (
    <section id="hero" className="relative w-full min-h-[580px] md:min-h-[640px] flex items-center bg-background-50 overflow-hidden">
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-gradient-to-br from-primary-50/80 via-background-50 to-accent-50/60"></div>
        <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-primary-100/30 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3"></div>
        <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-accent-100/25 rounded-full blur-3xl translate-y-1/2 -translate-x-1/4"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 py-16 md:py-20">
        <div className="max-w-[1400px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 text-xs font-semibold text-primary-700 bg-primary-100/80 rounded-full mb-5 whitespace-nowrap">
              {heroData.tag}
            </span>

            <h1 className="font-heading text-2xl md:text-4xl lg:text-5xl font-extrabold text-foreground-950 leading-tight mb-4">
              国产91视频
              <br className="md:hidden" />
              <span className="text-primary-500"> — </span>
              <span className="text-primary-500">手机看视频移动端播放首选平台</span>
            </h1>

            <p className="text-base md:text-lg text-foreground-600 font-medium mb-3">
              {heroData.slogan}
            </p>

            <p className="text-sm md:text-base text-foreground-500 leading-relaxed max-w-[580px] lg:max-w-none mb-8">
              {heroData.description}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              {heroData.stats.map((stat, i) => (
                <div key={i} className="text-center">
                  <div className="text-2xl md:text-3xl font-extrabold text-primary-500 font-heading">
                    {stat.value}
                  </div>
                  <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#app"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-full transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-download-cloud-2-line text-base"></i>
                {heroData.primaryCta.text}
              </a>
              <a
                href="#topics"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3 text-sm font-semibold text-foreground-700 bg-background-100 hover:bg-background-200 border border-background-300/60 rounded-full transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-fire-line text-base"></i>
                {heroData.secondaryCta.text}
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-[280px] h-[400px] md:w-[340px] md:h-[480px] lg:w-[380px] lg:h-[520px]">
              <div className="absolute inset-0 bg-gradient-to-br from-primary-200/40 via-accent-100/30 to-secondary-100/40 rounded-3xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20floating%20in%20center%20displaying%20vibrant%20video%20streaming%20app%20homepage%20with%20colorful%20content%20thumbnails%20and%20play%20buttons%2C%20surrounded%20by%20floating%20app%20icons%20in%20coral%20and%20amber%20tones%2C%20soft%20gradient%20background%20from%20warm%20white%20to%20light%20peach%2C%20modern%20UI%20design%20aesthetic%2C%20clean%20minimal%20composition%2C%203D%20render%20style%2C%20glass%20morphism%20effect%2C%20editorial%20quality&width=760&height=1040&seq=hero-visual-01&orientation=portrait"
                alt="国产91视频移动端播放界面展示"
                className="relative w-full h-full object-contain object-center"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}